<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #d02235;
}
.panoviewer {
  height: 100%;
}
.modalx-bg {
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 50px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
.modalx {
  font-family: 'Plus Jakarta Sans', sans-serif;
  background-color:#42b983 !important;
  color: white;
  overflow-x: clip;
  margin: auto;
  padding: 2rem;
  width: 50vw;
  max-height: 80%;
  overflow-y: scroll;
  transition: all 1s linear;
}
.modalx >>> a{
  color: white;
  font-weight: bold;
}
h2 {
  /* color: orange; */
  padding-bottom: 3rem;
}
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.blurred {
  filter: blur(5px);
  -webkit-filter: blur(5px);
  transition: all 1s linear;
}
.thumb {
  width: 20%;
  height: 5%;
  margin: 5px 5px 5px 5px;
}
p {
  text-align: left;
}
@media only screen and (max-width: 800px) {
  .modalx {
    width: 80vw;
    padding: 1rem;
  }
  .thumb {
    width: 30%;
    height: 5%;
    margin: 5px 5px 5px 5px;
  }
  h2 {
    padding-bottom: 1rem;
  }
  .mainphoto {
    width: 45%;
    max-height: 60%;
    margin: auto;
    display: block;
  }
}
</style>

<template>
  <div>
    <div id="viewer" class="panoviewer" :class="{blurred: viewSingle}">
    </div>
    <div v-show="viewSingle" @click="closeModal" class="modalx-bg">
      <!-- Modal content -->
      <div v-on:click.stop="()=>{}" class="modalx" ref="modalx">
        <button type="button" class="btn btn-outline-light btn-sm" v-show="audios[0]" @click="playAudio('audioES')">Espa&ntilde;ol</button>
        <button type="button" class="btn btn-outline-light btn-sm" v-show="audios[1]" @click="playAudio('audioEN')">Ingl&eacute;s</button>
        <button type="button" class="btn btn-outline-light btn-sm" v-show="audios[2]" @click="playAudio('audioNAH')">N&aacute;huatl</button>
        <audio ref="audioES" :src="audios[0]"/>
        <audio ref="audioEN" :src="audios[1]"/>
        <audio ref="audioNAH" :src="audios[2]"/>
        <span @click="closeModal" class="close">&times;</span>
        <!-- Content for each mark -->

        <!-- Lobby -->
        <Welcome v-if="markTemplate == 'welcome'"/>
        <Credits v-if="markTemplate == 'credits'"/>
        <Instituciones v-if="markTemplate == 'instituciones'"/>

        <!-- Sala 1 -->
        <Sala1Timeline v-if="markTemplate == 'sala1timeline'" @onImageClicked="imageClicked"/>
        <Sala11g00 v-if="markTemplate == 's1_p1g00'" @onImageClicked="imageClicked"/>
        <Sala12g02 v-if="markTemplate == 's1_p2g02'" @onImageClicked="imageClicked"/>
        <Sala12g03 v-if="markTemplate == 's1_p2g03'" @onImageClicked="imageClicked"/>
        <Sala12g04 v-if="markTemplate == 's1_p2g04'" @onImageClicked="imageClicked"/>
        <Sala12g05 v-if="markTemplate == 's1_p2g05'" @onImageClicked="imageClicked"/>
        <Sala12g06 v-if="markTemplate == 's1_p2g06'" @onImageClicked="imageClicked"/>
        <Sala12g07 v-if="markTemplate == 's1_p2g07'" @onImageClicked="imageClicked"/>
        <Sala12g08 v-if="markTemplate == 's1_p2g08'" @onImageClicked="imageClicked"/>
        <Sala12g09 v-if="markTemplate == 's1_p2g09'" @onImageClicked="imageClicked"/>
        <Sala12g10 v-if="markTemplate == 's1_p2g10'" @onImageClicked="imageClicked"/>
        <!-- Sala 2 -->
        <Sala21g00 v-if="markTemplate == 's2_p1g00'" @onImageClicked="imageClicked"/>
        <Sala21g01 v-if="markTemplate == 's2_p1g01'" @onImageClicked="imageClicked"/>
        <Sala22g02 v-if="markTemplate == 's2_p2g02'" @onImageClicked="imageClicked"/>
        <Sala22g03 v-if="markTemplate == 's2_p2g03'" @onImageClicked="imageClicked"/>
        <Sala22g04 v-if="markTemplate == 's2_p2g04'" @onImageClicked="imageClicked"/>
        <Sala22g05 v-if="markTemplate == 's2_p2g05'" @onImageClicked="imageClicked"/>
        <Sala22g06 v-if="markTemplate == 's2_p2g06'" @onImageClicked="imageClicked"/>
        <Sala22g07 v-if="markTemplate == 's2_p2g07'" @onImageClicked="imageClicked"/>
        <Sala22g08 v-if="markTemplate == 's2_p2g08'" @onImageClicked="imageClicked"/>
        <Sala22g09 v-if="markTemplate == 's2_p2g09'" @onImageClicked="imageClicked"/>
        <!-- Sala 3 -->
        <Sala31g00 v-if="markTemplate == 's3_p1g00'" @onImageClicked="imageClicked"/>
        <Sala31g01 v-if="markTemplate == 's3_p1g01'" @onImageClicked="imageClicked"/>
        <Sala32g02 v-if="markTemplate == 's3_p2g02'" @onImageClicked="imageClicked"/>
        <Sala32g03 v-if="markTemplate == 's3_p2g03'" @onImageClicked="imageClicked"/>
        <Sala32g04 v-if="markTemplate == 's3_p2g04'" @onImageClicked="imageClicked"/>
        <Sala32g05 v-if="markTemplate == 's3_p2g05'" @onImageClicked="imageClicked"/>
        <Sala32g06 v-if="markTemplate == 's3_p2g06'" @onImageClicked="imageClicked"/>
        <Sala32g07 v-if="markTemplate == 's3_p2g07'" @onImageClicked="imageClicked"/>
        <Sala32g08 v-if="markTemplate == 's3_p2g08'" @onImageClicked="imageClicked"/>
        <Sala32g09 v-if="markTemplate == 's3_p2g09'" @onImageClicked="imageClicked"/>

        <img class="thumb" v-show="images.length > 1" v-for="(image, i) in images" :key="image" :src="image" @click="index = i">
        <vue-gallery-slideshow :images="images" :index="index" @close="index = null"></vue-gallery-slideshow>
      </div>

    </div>
    <wafloater phone="++5212212570586"/>
  </div>
</template>

<script>
import { Viewer } from "photo-sphere-viewer";

// MUCHO OJO con la sintaxis, cambio a usarse asi { MarkersPlugin }
import { MarkersPlugin } from "photo-sphere-viewer/dist/plugins/markers";

import "photo-sphere-viewer/dist/photo-sphere-viewer.css";
import "photo-sphere-viewer/dist/plugins/markers.css";
import VueGallerySlideshow from "vue-gallery-slideshow";
import Wafloater from "@/components/Wafloater.vue";
import Salas from "@/assets/SalasConf";
// // Lobby
import Welcome from "./lobby/welcome.vue";
import Credits from "./lobby/credits.vue";
import Instituciones from "./lobby/instituciones.vue";
// Sala 1
import Sala1Timeline from "./sala1/sala1timeline.vue";
import Sala11g00 from "./sala1/s1_p1g00.vue";
import Sala12g02 from "./sala1/s1_p2g02.vue";
import Sala12g03 from "./sala1/s1_p2g03.vue";
import Sala12g04 from "./sala1/s1_p2g04.vue";
import Sala12g05 from "./sala1/s1_p2g05.vue";
import Sala12g06 from "./sala1/s1_p2g06.vue";
import Sala12g07 from "./sala1/s1_p2g07.vue";
import Sala12g08 from "./sala1/s1_p2g08.vue";
import Sala12g09 from "./sala1/s1_p2g09.vue";
import Sala12g10 from "./sala1/s1_p2g10.vue";
// Sala 2
import Sala21g00 from "./sala2/s2_p1g00.vue";
import Sala21g01 from "./sala2/s2_p1g01.vue";
import Sala22g02 from "./sala2/s2_p2g02.vue";
import Sala22g03 from "./sala2/s2_p2g03.vue";
import Sala22g04 from "./sala2/s2_p2g04.vue";
import Sala22g05 from "./sala2/s2_p2g05.vue";
import Sala22g06 from "./sala2/s2_p2g06.vue";
import Sala22g07 from "./sala2/s2_p2g07.vue";
import Sala22g08 from "./sala2/s2_p2g08.vue";
import Sala22g09 from "./sala2/s2_p2g09.vue";
// Sala 3
import Sala31g00 from "./sala3/s3_p1g00.vue";
import Sala31g01 from "./sala3/s3_p1g01.vue";
import Sala32g02 from "./sala3/s3_p2g02.vue";
import Sala32g03 from "./sala3/s3_p2g03.vue";
import Sala32g04 from "./sala3/s3_p2g04.vue";
import Sala32g05 from "./sala3/s3_p2g05.vue";
import Sala32g06 from "./sala3/s3_p2g06.vue";
import Sala32g07 from "./sala3/s3_p2g07.vue";
import Sala32g08 from "./sala3/s3_p2g08.vue";
import Sala32g09 from "./sala3/s3_p2g09.vue";

export default {
  name: "HelloWorld",
  data() {
    return {
      viewer: "",
      marks: this.sala.length > 0 ? Salas[this.sala].marks : Salas.lobby.marks,
      imgurl1: this.sala.length > 0 ? Salas[this.sala].pano : Salas.lobby.pano,
      panoramadata: null,
      loading_img: "../../static/pano/assets/photosphere-logo.gif",
      photosphere: "photosphere",
      imageLoaded: false,
      viewSingle: false,
      markTemplate: "",
      content: "",
      images: [],
      audios: [],
      index: null
    };
  },
  methods: {
    imageClicked(idx) {
      this.index = idx;
    },
    closeModal() {
      this.viewSingle = false;
      this.markTemplate = "";
      this.stopAudios();
    },
    playAudio(audioComponent) {
      this.stopAudios();
      const audiosNames = ["audioES", "audioEN", "audioNAH"];
      const audioFile = this.audios[audiosNames.indexOf(audioComponent)] ?? "";

      if (audioFile !== "") {
        this.$refs[audioComponent].play();
      }
    },
    stopAudios() {
      this.$refs.audioES.pause();
      this.$refs.audioEN.pause();
      this.$refs.audioNAH.pause();
      this.$refs.audioES.currentTime = 0;
      this.$refs.audioEN.currentTime = 0;
      this.$refs.audioNAH.currentTime = 0;
    }
  },
  components: {
    VueGallerySlideshow,
    Welcome,
    Credits,
    Instituciones,

    Sala1Timeline,
    Sala11g00,
    Sala12g02,
    Sala12g03,
    Sala12g04,
    Sala12g05,
    Sala12g06,
    Sala12g07,
    Sala12g08,
    Sala12g09,
    Sala12g10,

    Sala21g00,
    Sala21g01,
    Sala22g02,
    Sala22g03,
    Sala22g04,
    Sala22g05,
    Sala22g06,
    Sala22g07,
    Sala22g08,
    Sala22g09,

    Sala31g00,
    Sala31g01,
    Sala32g02,
    Sala32g03,
    Sala32g04,
    Sala32g05,
    Sala32g06,
    Sala32g07,
    Sala32g08,
    Sala32g09,
  },
  props: {
    sala: {
      type: String,
      default: ""
    }
  },
  mounted() {
    // console.log(M);
    this.viewer = new Viewer({
      container: document.querySelector("#viewer"),
      panorama: this.imgurl1,
      navbar: false,
      defaultZoomLvl: 0,
      defaultLat: 0,
      defaultLong: 1.0,
      loadingTxt: "Cargando...",
      size: {
        width: "100vw",
        height: "100vh"
      },
      plugins: [[MarkersPlugin, { markers: this.marks }]]
    });
    // this.viewer.plugins.markers;
    this.viewer.on("click", (e, data) => {
      console.log("Clicked", data.longitude, data.latitude, data);
    });
    // this.viewer.on("click", (e, dblclick) => {
    //   console.log("Clicked outside", e.target, dblclick);
    // });
    // this.viewer.on("position-updated", (e, position) => {
    //   console.log(`new position is longitude: ${position.longitude} latitude: ${position.latitude}`);
    // });
    this.viewer.plugins.markers.on("select-marker", (e, marker) => {
      const { id = "" } = marker;
      const parts = id.split(":");
      const [cmd = "mark", arg = null] = parts;
      console.log("Markers:", e, id, cmd, arg);
      if (cmd === "exit" && arg) {
        console.log("Exiting to", arg);
        this.viewer.setPanorama(Salas[arg].pano);
        this.viewer.zoom(0);
        this.viewer.plugins.markers.setMarkers(Salas[arg].marks);
        this.marks = Salas[arg].marks;
        return;
      }

      if (cmd === "link" && arg) {
        console.log("link to", arg);
        this.$router.replace( { name: "Game", params: { sala: arg } });
        return;
      }

      const [currentMark = {}] = this.marks.filter(m => m.id === id);
      const { info = {} } = currentMark;
      const { template = "", images = [], audios = [] } = info;

      this.audios = audios;
      this.markTemplate = template;
      this.images = images;
      this.viewSingle = true;

      this.$nextTick(() => {
        this.$refs.modalx.scrollTop = 0;
        if (audios.length > 0) {
          this.stopAudios();
          this.$refs.audioES.play();
        }
      });
    });
  }
};
</script>
